import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const observationService = {
  getList,
  storeOrUpdateObservation,
  destroy,
  viewObservation
};

function buildQueryString(propertyId, params = {}) {
  const searchParams = new URLSearchParams();
  if (propertyId) {
    searchParams.append('property_id', propertyId);
  }
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
}

function getList(propertyId, params = {}){
  const queryString = buildQueryString(propertyId, params);
  return (
    axios
      .get(
        `${apiEndpoint.observations}?${queryString}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function storeOrUpdateObservation(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.observations(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.observations,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.observations(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function viewObservation(id){
  return (
    axios
      .get(
        apiEndpointFunction.observations(id),
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}
